import React from "react";

import adventure from "./adventure.svg";
import advertising from "./advertising.svg";
// import beauty from "./beauty.svg";
import delivery from "./delivery.svg";
import design from "./design.svg";
import education from "./education.svg";
import facebook from "./facebook.svg";
import food from "./food.svg";
import health from "./health.svg";
import instagram from "./instagram.svg";
import pickup from "./pickup.svg";
import retail from "./retail.svg";
import trades from "./trades.svg";
import twitter from "./twitter.svg";
import email from "./email.svg";
import loading from "./svg.svg";
import nobusinesses from "./no-businesses.svg";

const icons = [
  { name: "Adventure, Travel and Tourism", svgObj: adventure },
  { name: "Advertising, Arts & Media", svgObj: advertising },
  { name: "Design and Architecture", svgObj: design },
  { name: "Education and Childcare", svgObj: education },
  { name: "Food and Drink", svgObj: food },
  { name: "Health, Beauty and Fitness", svgObj: health },
  { name: "Health, Fitness and Beauty", svgObj: health },
  { name: "Retail", svgObj: retail },
  { name: "Trades and Services", svgObj: trades },
  { name: "Travel, Adventure and Tourism", svgObj: adventure },
  { name: "Facebook", svgObj: facebook },
  { name: "Instagram", svgObj: instagram },
  { name: "Twitter", svgObj: twitter },
  { name: "Email", svgObj: email },
  { name: "Delivery", svgObj: delivery },
  { name: "Pick Up", svgObj: pickup },
  { name: "pickup", svgObj: pickup },
  { name: "nobusinesses", svgObj: nobusinesses },
  { name: "Adventure, Travel & Tourism", svgObj: adventure },
  { name: "Design & Architecture", svgObj: design },
  { name: "Education & Childcare", svgObj: education },
  { name: "Food & Drink", svgObj: food },
  { name: "Health, Beauty & Fitness", svgObj: health },
  { name: "Health, Fitness & Beauty", svgObj: health },
  { name: "Trades & Services", svgObj: trades },
  { name: "Travel, Adventure & Tourism", svgObj: adventure },
];

const Svg = ({ name, width = 20, height = 20 }) => {
  const styles = {
    width: width + "px",
    height: height + "px",
  };

  const buttonObj = icons.filter(
    (icon) => icon.name.toLowerCase() === name.toLowerCase()
  );
  const theSvg = buttonObj && buttonObj[0] ? buttonObj[0].svgObj : loading;

  return <img src={theSvg} style={styles} alt={name} />;
};

export default Svg;
